import { registerApi as api } from '../../api';

export const uploadCtcMaster = async (fileData) => {
    try {
        const formData = new FormData();
        formData.append('file', fileData);
        const token = sessionStorage.getItem('token');
        const selectedClientID = sessionStorage.getItem('selectedClient')
        const response = await api.post('/upload_ctc_master', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            },
            params : {
                'selectedClientID' : selectedClientID
            },
            timeout: 120000 // 2 minutes for large ctc master uploads (1500+ rows)
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const fetchCtcMaster = async (current_month) => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_ctc_master/${current_month}`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateCtcMaster = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_ctc_master/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteCtcMaster = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_ctc_master/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteCtcMaster = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/delete_multiple_ctc_master', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        console.log(response.data);
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
